<template>
  <el-dialog
    title="流程回滚"
    :visible.sync="visible"
    width="400px"
    @close="$emit('update:show', false)"
    @open="opened()"
  >
    <el-form ref="form" label-width="70px" :model="model" :rules="formRules">
      <el-form-item label="回滚到" prop="mode_status">
        <el-select
          style="width: 100%"
          v-model="model.mode_status"
          placeholder="请选择"
        >
          <el-option
            v-for="item in steps"
            :key="item.value"
            :label="item.label"
            :value="parseInt(item.value)"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { ServiceQuestFlow, ServiceQuestModeStatus } from '../config/global'
import {
  serviceQuestDone,
  serviceQuestRollback,
  userList,
} from '../service/getData'

import { serviceQuestRollbackV2 } from '../service/getDataV2'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    serviceQuest: {
      type: Object,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      formRules: {
        mode_status: [
          { required: true, message: '请选择回滚步骤', trigger: 'change' },
        ],
      },
      submiting: false,
      steps: [],
    }
  },
  methods: {
    async opened() {
      if (this.serviceQuest.is_new_flow) {
        let steps = this.clone(this.serviceQuest.steps)
        steps.shift()
        steps = steps.filter(
          (item) =>
            (!!item.finished_at || item.father_id == -1) && item.step_id != -100
        )
        this.steps = steps.map((item) => {
          return { label: item.name, value: item.id }
        })
        return
      }
      if (this.serviceQuest.id > 0) {
        let defaults = ServiceQuestFlow[this.serviceQuest.mode].map((item) => {
          return item
        })
        defaults.splice(0, 1)
        let cur = defaults.indexOf(this.serviceQuest.mode_status)
        if (this.serviceQuest.status == 100) {
          cur = 100
        }
        let steps = []
        for (let index = 0; index < defaults.length; index++) {
          const step = defaults[index]
          if (index < cur) {
            steps.push({ value: step, label: ServiceQuestModeStatus[step] })
          }
        }
        this.steps = steps
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          let res
          if (this.serviceQuest.is_new_flow) {
            res = await serviceQuestRollbackV2(this.model)
          } else {
            res = await serviceQuestRollback(this.model)
          }
          if (res.code == 0) {
            this.$emit('refresh')
          }
          this.submiting = false
          this.visible = false
        } else {
          this.submiting = false
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>